import { render, staticRenderFns } from "./CreateTransferSchedule.vue?vue&type=template&id=0b5277e4"
import script from "./CreateTransferSchedule.vue?vue&type=script&lang=js"
export * from "./CreateTransferSchedule.vue?vue&type=script&lang=js"
import style0 from "./CreateTransferSchedule.vue?vue&type=style&index=0&id=0b5277e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports